import React from 'react';
import { Flex, ListItem, Text, UnorderedList } from '@chakra-ui/react';

type OptionLabels = {
  main: string;
  secondary?: string;
};

type IProps = {
  value: string[];
  subtitle?: string;
  options: Record<string, OptionLabels>;
};

export const CheckBoxArrayDisplay: React.FC<IProps> = ({
  value,
  subtitle,
  options
}) => {
  const displayValues = value.map(v => options[v]?.main || v).filter(Boolean);

  return (
    <Flex flexDirection="column">
      <UnorderedList styleType="disc" pl={4}>
        {displayValues.map(value => (
          <ListItem key={value}>
            <Text textStyle="textBody">{value}</Text>
          </ListItem>
        ))}
      </UnorderedList>
      {subtitle && <Text textStyle="textBody">{subtitle}</Text>}
    </Flex>
  );
};
